import MoreVertIcon from "@mui/icons-material/MoreVert";
import { AssignmentIndOutlined, EmailOutlined, PersonAddOutlined } from "@mui/icons-material";
import { IconButton, Popover } from "@mui/material";
import { useState } from "react";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

/** Shared client row actions menu. */
export function ClientActionsMenu({ item, onAssignTask, onDelete, size = "medium" }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const close = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        size={size}
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
        aria-label="Client actions"
      >
        <MoreVertIcon className="text-app-text-secondary" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={close}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        marginThreshold={12}
      >
        <div className="p-1.5 min-w-[200px]">
          <button
            type="button"
            className="flex w-full items-center gap-2 p-2.5 hover:bg-app-surface-hover rounded text-left text-sm"
            onClick={() => {
              window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${item?.email}`, "_blank");
              close();
            }}
          >
            <EmailOutlined className="text-primary" fontSize="small" />
            Send Email
          </button>
          <button
            type="button"
            className="flex w-full items-center gap-2 p-2.5 hover:bg-app-surface-hover rounded text-left text-sm"
            onClick={() => {
              onAssignTask?.(item);
              close();
            }}
          >
            <AssignmentIndOutlined className="text-primary" fontSize="small" />
            Assign Task
          </button>
          <button
            type="button"
            className="flex w-full items-center gap-2 p-2.5 hover:bg-app-surface-hover rounded text-left text-sm"
            onClick={() => {
              navigate("/admin/admission/add", {
                state: { preselectClientId: item?.id, preselectClient: item },
              });
              close();
            }}
          >
            <PersonAddOutlined className="text-primary" fontSize="small" />
            Create Admission
          </button>
          <button
            type="button"
            className="flex w-full items-center gap-2 p-2.5 hover:bg-app-surface-hover rounded text-left text-sm"
            onClick={() => {
              navigate(`/admin/client/edit/${item?.id}`, { state: { item } });
              close();
            }}
          >
            <AiFillEdit className="text-primary" />
            Edit Client
          </button>
          <button
            type="button"
            className="flex w-full items-center gap-2 p-2.5 hover:bg-app-surface-hover rounded text-left text-sm text-red-600"
            onClick={() => {
              onDelete?.(item);
              close();
            }}
          >
            <AiFillDelete className="text-red-600" />
            Delete Client
          </button>
        </div>
      </Popover>
    </>
  );
}
